import { Text, VStack } from '@chakra-ui/react'
import { routes } from '../../routes'
import { Link } from 'react-router-dom'

export const NoRemainingTokensNotificationContent = () => {
  return (
    <VStack alignItems={'stretch'}>
      <Text>You have reached your monthly prescription limit.</Text>
      <Text paddingBottom={8}>
        To start sending prescriptions again, please contact your organisation administrator. Click{' '}
        <Link to={`${routes.settings.path}?tab=users`} style={{ color: 'dodgerblue' }}>
          here
        </Link>{' '}
        to check organisation users.
      </Text>
    </VStack>
  )
}
